<ta-page-container>
  <ta-page-header>
    <div class="h--100 flex items--center">
      <span class="heading--1">Your User Settings</span>
    </div>
  </ta-page-header>

  <ta-page-body>
    <ta-box padding="4rem 8rem" margin="0 0 4rem 0" class="border--bottom">
      <span class="thin-heading--1">
        <span>{{'Your User Settings' | uppercase}}</span>
      </span>
    </ta-box>
    <div class="ph--6 pv--6">
      <div class="pb--3">
        <ta-form-field
          label="Name"
          [errors]="validationResult?.errors?.nested?.name"
          [forceShowErrors]="forceShowErrors"
          [dirty]="userForm.get('name')?.dirty"
        >
          <ta-input type="text" [formControl]="userForm.get('name')"></ta-input>
        </ta-form-field>
      </div>

      <div class="pb--3">
        <ta-button
          *ngIf="!changePassword; else changePasswordFields"
          (taInteract)="changePassword = true"
        >
          {{ user.usesPassword ? "Change Password" : "Set Password" }}
        </ta-button>
      </div>

      <ng-template #changePasswordFields>
        <div class="pb--3">
          <ta-form-field
            label="Password"
            [errors]="validationResult?.errors?.nested?.password"
            [forceShowErrors]="forceShowErrors"
            [dirty]="userForm.get('password')?.dirty"
            class="pb--3"
          >
            <ta-input
              type="password"
              [formControl]="userForm.get('password')"
            ></ta-input>
          </ta-form-field>
        </div>

        <div class="pb--3">
          <ta-form-field
            label="Confirm Password"
            [errors]="validationResult?.errors?.nested?.passwordConfirm"
            [forceShowErrors]="forceShowErrors"
            [dirty]="userForm.get('passwordConfirm')?.dirty"
            class="pb--3"
          >
            <ta-input
              type="password"
              [formControl]="userForm.get('passwordConfirm')"
            ></ta-input>
          </ta-form-field>
        </div>
      </ng-template>

      <ta-button priority="primary" (taInteract)="save()" [disabled]="saving">
        {{ saving ? "Saving..." : "Save Changes"}}
      </ta-button>
    </div>
  </ta-page-body>
</ta-page-container>

<ng-template taModalTemplate position="top" #modal="taModalTemplate" let-modal>
  <div class="modal modal--small p--6">
    <h1 class="heading--1">Save User Settings Changes</h1>

    <div class="pb--3">
      <p class="section">Please enter your current password to save changes:</p>

      <ta-form-field label="Current Password">
        <ta-input type="password" #password></ta-input>
      </ta-form-field>
    </div>

    <ta-flexbox justifyContent="space-between">
      <ta-button (taInteract)="modal.dismiss()"> Cancel </ta-button>
      <ta-button priority="primary" (taInteract)="modal.close(password.value)">
        Save Changes
      </ta-button>
    </ta-flexbox>
  </div>
</ng-template>
